import { render } from "./BillingSupplierPage.vue?vue&type=template&id=0709558f&ts=true"
import script from "./BillingSupplierPage.vue?vue&type=script&lang=ts"
export * from "./BillingSupplierPage.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__